export default {
  'auditReport.active': 'Active',
  'auditReport.allUsers': 'All Users Selected',
  'auditReport.selectedUsers': '<%=number %> Users Selected',
  'auditReport.inactive': 'Inactive',
  'auditReport.ipAddress': 'IP Address',
  'auditReport.lockMessage': 'Navigate to User Admin to unlock User.',
  'auditReport.mobile': 'Mobile',
  'auditReport.sessionId': 'Session ID',
  'auditReport.action': 'Action Taken',
  'auditReport.userSession': 'User Session',
  'auditReport.web': 'WEB',
  'auditReport.web2': 'WEB2',
  'auditReport.filter.userID': 'User ID',
  'auditReport.filter.dateNTime': 'Date And Time'
};
